import React from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, Home as HomeIcon } from 'lucide-react';
import { mockData } from '../mock/data';

const Temoignages = () => {
  const allTestimonials = [
    {
      id: 1,
      stars: 5,
      quote: "Avant NeoNkawa, j'étais stressé à chaque turnover. Des fois le nettoyeur venait, des fois non. Maintenant je dors tranquille. Ma note Airbnb est passée de 4.7 à 4.9 en 3 mois. Les photos qu'ils m'envoient après chaque nettoyage me rassurent complètement.",
      name: "Hassan",
      badge: "Superhost 3 appartements",
      location: "Hamria, Meknès",
      avatar: "https://ui-avatars.com/api/?name=Hassan&background=0099FF&color=fff&size=128",
      properties: 3,
      months: 8
    },
    {
      id: 2,
      stars: 5,
      quote: "Le système de photos après chaque nettoyage = game changer. Je n'ai plus besoin de me déplacer pour vérifier. Tout est nickel à chaque fois. L'équipe est ponctuelle et professionnelle. Je recommande à tous les hôtes de Meknès.",
      name: "Fatima",
      badge: "Superhost 2 appartements",
      location: "Ville Nouvelle, Meknès",
      avatar: "https://ui-avatars.com/api/?name=Fatima&background=00C878&color=fff&size=128",
      properties: 2,
      months: 6
    },
    {
      id: 3,
      stars: 5,
      quote: "Service rapide et fiable. Ils ont sauvé mes fesses plusieurs fois avec des bookings last-minute. Une fois, j'ai eu un checkout à 11h et un check-in à 15h. Ils ont tout géré en 2h30. Le client suivant a laissé 5 étoiles.",
      name: "Karim",
      badge: "Host Airbnb",
      location: "Hamria, Meknès",
      avatar: "https://ui-avatars.com/api/?name=Karim&background=0099FF&color=fff&size=128",
      properties: 1,
      months: 4
    },
    {
      id: 4,
      stars: 5,
      quote: "J'ai testé 3 services de nettoyage avant NeoNkawa. C'est le seul qui respecte vraiment la checklist. Pas de détails oubliés, jamais. Le rapport qualité-prix est excellent, surtout avec l'abonnement mensuel.",
      name: "Youssef",
      badge: "Superhost 4 appartements",
      location: "Ville Nouvelle, Meknès",
      avatar: "https://ui-avatars.com/api/?name=Youssef&background=00C878&color=fff&size=128",
      properties: 4,
      months: 12
    },
    {
      id: 5,
      stars: 5,
      quote: "Ponctualité irréprochable. En 5 mois, pas une seule fois de retard. L'équipe arrive à l'heure, fait le travail, m'envoie les photos et c'est réglé. Simple et efficace. C'est exactement ce dont j'avais besoin.",
      name: "Salma",
      badge: "Host Airbnb",
      location: "Centre-ville, Meknès",
      avatar: "https://ui-avatars.com/api/?name=Salma&background=0099FF&color=fff&size=128",
      properties: 1,
      months: 5
    },
    {
      id: 6,
      stars: 5,
      quote: "L'abonnement mensuel est une excellente affaire. J'ai 2 apparts avec beaucoup de turnovers. Avec 8 nettoyages par mois à 150 DH au lieu de 180, j'économise 240 DH. Et en plus, j'ai un agent dédié qui me connaît.",
      name: "Mehdi",
      badge: "Superhost 2 appartements",
      location: "Hamria, Meknès",
      avatar: "https://ui-avatars.com/api/?name=Mehdi&background=00C878&color=fff&size=128",
      properties: 2,
      months: 7
    }
  ];

  const stats = [
    { number: "98%", label: "Satisfaction clients" },
    { number: "4.9★", label: "Note moyenne" },
    { number: "20+", label: "Avis 5 étoiles" },
    { number: "50+", label: "Hôtes fidèles" }
  ];

  return (
    <div className="temoignages-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Ce Que Disent Nos Clients</h1>
          <p>Plus de 50 hôtes Airbnb à Meknès nous font confiance pour protéger leur note</p>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-section">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="testimonials-full-section">
        <div className="section-container">
          <h2>Avis de nos Superhosts</h2>
          <div className="testimonials-full-grid">
            {allTestimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-full-card">
                <div className="testimonial-header">
                  <img src={testimonial.avatar} alt={testimonial.name} className="avatar-large" />
                  <div className="testimonial-info">
                    <h3>{testimonial.name}</h3>
                    <p className="badge-text">{testimonial.badge}</p>
                    <p className="location-text">
                      <MapPin size={14} />
                      {testimonial.location}
                    </p>
                  </div>
                </div>
                
                <div className="stars-large">
                  {[...Array(testimonial.stars)].map((_, i) => (
                    <Star key={i} size={24} fill="#FFC107" color="#FFC107" />
                  ))}
                </div>
                
                <p className="quote-large">"{testimonial.quote}"</p>
                
                <div className="testimonial-meta">
                  <div className="meta-badge">
                    <HomeIcon size={16} />
                    <span>{testimonial.properties} {testimonial.properties > 1 ? 'propriétés' : 'propriété'}</span>
                  </div>
                  <div className="meta-badge">
                    <span>Client depuis {testimonial.months} mois</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="trust-section">
        <h2>Rejoignez les Hôtes Satisfaits</h2>
        <div className="trust-stars">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={48} fill="#FFC107" color="#FFC107" />
          ))}
        </div>
        <p className="trust-text">Note moyenne 4.9/5 basée sur 20+ avis vérifiés</p>
      </section>

      {/* CTA */}
      <section className="service-cta">
        <h2>Prêt à Protéger Votre Note Airbnb?</h2>
        <p>Rejoignez les Superhosts qui nous font confiance</p>
        <div className="cta-buttons">
          <Link to="/contact" className="white-btn">Réserver Mon Nettoyage</Link>
          <a href="https://wa.me/212653555855" target="_blank" rel="noopener noreferrer" className="outline-white-btn">
            Parler sur WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
};

export default Temoignages;
